import { useTranslation } from 'react-i18next';
import React, { useEffect } from 'react';
import './index.scss';
import { ButtonPrimary, ErrorFeedbackScreen } from '@telefonica/mistica';
import { useLocation, useNavigate } from 'react-router-dom';
import navigateParams from '../../../../utils/navigation/navigateParams';
import { TrackingEvents } from '../../../../utils/dataTransformation/tracking';
import { isWebviewAndroid, isWebviewIOS } from '../../../../utils/navigation/controlDevices';

interface IFeedbackContactVerificationData {
    stateFeedback: string;
    err: any;
}
export const FeedbackAgreement: React.FC = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { state } = useLocation();
    const { trackingScreenView } = new TrackingEvents();
    const { stateFeedback, err }: IFeedbackContactVerificationData = state;

    const sendToNative = (url: string, title?: string) => {
        const type = 'modeFlow-backgroundBlue';
        const queryParams = {};
        const storage = {};
        if (navigateParams(type, url, queryParams, storage, title)) {
            navigate(url);
        }
    };
    useEffect(() => {
        if (!(isWebviewAndroid || isWebviewIOS)) {
            trackingScreenView();
        }
    }, []);

    return (
        <div className='feedbackAddData-page'>
            <ErrorFeedbackScreen
                title={err.title}
                description={err.localizedDescription}
                errorReference={'Código de error: ' + `${err.id}`}
                primaryButton={
                    <ButtonPrimary
                        onPress={() => {
                            sendToNative('/profile/customer-agreement', 'Datos de reconocimiento');
                        }}
                    >
                        {t('buttonUnderstoodFeedback')}
                    </ButtonPrimary>
                }
            ></ErrorFeedbackScreen>
        </div>
    );
};

export default FeedbackAgreement;
